mutation UpdateNextMessage($input: UpdateNextMessageInput!) {
  updateNextMessage(input: $input) {
    textBody
    htmlBody
    mjmlBody
    editedTextBody
    subject
    scheduledAt
    runId
    stepId
    automationId
    attachments {
      id
      fileId
      name
      content
      contentType
      size
      url
      path
    }
  }
}
